import $ from "jquery";

$(() => {
  var path = window.location.pathname;
  if (path === "/account/manage") {
    initModule();
  }
});

function initModule() {
  $("#password").on("input", function () {
    var enable = false;
    if ($(this).val().length > 0) {
      enable = true;
    }

    $("#password-verify").prop("disabled", !enable);
    $("#password-verify").prop("required", enable);
  });

  $("#password").trigger("input");
}
